export const SIGN_MODAL_UI = 'SIGN_MODAL_UI';
export const STEPS = {
  FIRST: 1,
  SECOND: 2
};
